import { LockOutlined } from '@mui/icons-material';
import type { MixtureMonthSummary as MixtureMonthSummaryData } from '../../utils/mixturesMapper';
import styles from './MixtureMonthSummary.module.css';

const litersFormatter = new Intl.NumberFormat('pt-BR');

export const MixtureMonthSummary = ({ summary }: { summary: MixtureMonthSummaryData }) => (
	<div className={styles.card}>
		<div className={styles.columns}>
			<div className={styles.column}>
				<span className={styles.label}>Área</span>
				<strong className={styles.value}>{summary.areaName || '—'}</strong>
			</div>
			<div className={`${styles.column} ${styles.chipsColumn}`}>
				<span className={styles.label}>Setores</span>
				<div className={styles.chips}>
					{summary.sectorNames.map((name) => (
						<span key={name} className={styles.chip}>
							{name}
						</span>
					))}
				</div>
			</div>
			<div className={styles.column}>
				<span className={styles.label}>Vol. da caixa</span>
				<span>
					<strong className={styles.value}>
						{summary.vbox != null ? litersFormatter.format(summary.vbox) : '—'}
					</strong>
					<span className={styles.unit}> {summary.vbox === 1 ? 'litro' : 'litros'}</span>
				</span>
			</div>
			<div className={styles.column}>
				<span className={styles.label}>Parcelas no mês</span>
				<span>
					<strong className={styles.value}>{summary.applications}</strong>
					<span className={styles.unit}>
						{' '}
						{summary.applications === 1 ? 'aplicação' : 'aplicações'}
					</span>
				</span>
			</div>
		</div>
		<span className={styles.hint}>
			<LockOutlined className={styles.hintIcon} />
			dados do parcelamento
		</span>
	</div>
);
